import React from 'react';
import { Back, Banner } from '../../components';
import { Body, Wrapper, Facts, Content } from './Article.styled';

export default function Article({
	date,
	title,
	image,
	gradient,
	subtitle,
	children,
}) {
	return (
		<Wrapper gradient={gradient}>
			<Back title="Back to projects" />
			<Banner image={image} title={title} subtitle={subtitle} />
			<Content className="content">
				<Facts>
					<time>{date}</time>
				</Facts>
				<Body>{children}</Body>
			</Content>
		</Wrapper>
	);
}
